"use client"

import { usePathname } from "next/navigation"

/**
 * Hides children on policy/chat pages.
 * Minimal client boundary for pathname detection.
 */
export function HideOnPolicyPages({ children }: { children: React.ReactNode }) {
    const pathname = usePathname()

    const hiddenPaths = ["/privacy-policy", "/terms-of-service", "/cookie-policy", "/chat"]
    if (hiddenPaths.includes(pathname)) {
        return null
    }

    return <>{children}</>
}
